import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as IntegrationsActions from "../data/integrations/IntegrationsActions";

import BlankIntegrationsList from "../components/BlankStates/BlankIntegrationsList";
import Button from "UI/Button";
import ChooseNewIntegrationDialog from "Components/ChooseNewIntegrationDialog";
import Container from '../components/Container';
import Heading from "UI/Heading";
import IntegrationList from "../components/IntegrationList";
import IntegrationSkeleton from "../components/Skeletons/IntegrationSkeleton";
import Plus from 'UI/Heroicons/Plus';
import Puzzle from "UI/Heroicons/Puzzle";

class IntegrationsController extends React.Component
{
    state = {
        showIntegrationsDialog: false
    };

    static propTypes = {
        accountId: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired
    };

    render()
    {
        const actions = <Button className='space-x-2' type='primary' onClick={() => this.setState({showIntegrationsDialog: true})} >
            <Plus className='w-5' />
            <span>Setup an Integration</span>
        </Button>;

        const title = <div className='flex'>
            <Puzzle className='w-7 mr-3' />Integrations
        </div>;

        return <Container>
            <Heading
                title={title}
                description='Extend what Patchwork can do with Integrations with other platforms and services.'
                actions={actions} />

            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6'>
                { this.props.loading ? <IntegrationSkeleton /> : <IntegrationList integrations={this.props.integrations} /> }
            </div>

            { this.renderBlankState() }

            <ChooseNewIntegrationDialog
                open={this.state.showIntegrationsDialog}
                onClose={() => this.setState({showIntegrationsDialog: false})}
            />
        </Container>;
    }

    renderBlankState()
    {
        if ( this.props.loading ) {
            return null;
        }

        const activeIntegrations = _.filter(this.props.integrations, integration => ! integration.disconnected_at);

        if (_.size(activeIntegrations) > 0) {
            return null;
        }

        return <div className='relative'>
            <BlankIntegrationsList className='absolute right-0 w-64 mr-24 -mt-8 text-gray-600' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    integrations: state.integrations,
});

const mapDispatchToProps = {
    listIntegrations: IntegrationsActions.listIntegrations,
};

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationsController);
